import clsx from "clsx"
import { motion } from "framer-motion"
import { GatsbyImage } from "gatsby-plugin-image"
import React, { forwardRef } from "react"

function Logo({ title, logo }) {
  if (!title && !logo) return null
  return (
    <div>
      {title && <h4 className="">{title}</h4>}
      {logo && !title && (
        <GatsbyImage
          classname=""
          altText={logo.altText}
          width="79"
          height="24"
          image={logo?.localFile?.childImageSharp?.gatsbyImageData}
        />
      )}
    </div>
  )
}

function MenuIcon(props) {
  return (
    <svg viewBox="0 0 24 24" fill="none" aria-hidden="true" {...props}>
      <path
        d="M5 6h14M5 18h14M5 12h14"
        stroke="#000"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

function UserIcon(props) {
  return (
    <svg viewBox="0 0 24 24" fill="none" aria-hidden="true" {...props}>
      <path
        d="M15 8a3 3 0 1 1-6 0 3 3 0 0 1 6 0ZM6.696 19h10.608c1.175 0 2.08-.935 1.532-1.897C18.028 15.69 16.187 14 12 14s-6.028 1.689-6.836 3.103C4.616 18.065 5.521 19 6.696 19Z"
        stroke="#000"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

const AppScreenHeader = forwardRef(function AppScreenHeader({ children }, ref) {
  return <div ref={ref}>{children}</div>
})

const MotionAppScreenHeader = motion(AppScreenHeader)

export function AppScreen({
  children,
  className,

  item: {
    withTopbar,
    withMenuIcon,
    withTitleOrLogo,
    withOverlay,
    screenTitle,
    screenLogo,
    withUserIcon,
  },
  ...props
}) {
  return (
    <div
      className={clsx("flex flex-col bg-aliceBlue-500", className)}
      {...props}
    >
      <MotionAppScreenHeader
        {...{
          initial: { opacity: 0, transition: { duration: 0.1 } },
          animate: { opacity: 1, transition: { duration: 0, delay: 0 } },
          exit: { opacity: 0, transition: { duration: 0 } },
        }}
      >
        <div
          className={`flex relative justify-between px-4 pt-4 pb-2 ${
            withTopbar ? "border-b" : "h-11"
          }`}
        >
          {withMenuIcon && <MenuIcon className="h-6 w-6 flex-none" />}
          {withTitleOrLogo && (
            <Logo
              title={screenTitle}
              logo={screenLogo}
              className="h-6 flex-none"
            />
          )}
          {withUserIcon && <UserIcon className="h-6 w-6 flex-none" />}
        </div>
        {withOverlay && (
          <div
            className="absolute inset-0 "
            style={{
              backgroundColor: "rgba(0, 0, 0, 0.1)",
              bottom: "0",
              top: "0",
            }}
          />
        )}
      </MotionAppScreenHeader>
      {children}
    </div>
  )
}

AppScreen.Body = forwardRef(function AppScreenBody(
  { children, className },
  ref
) {
  return (
    <div ref={ref} className={clsx("flex-auto rounded-t-2xl", className)}>
      {children}
    </div>
  )
})
